<template>
    <div>
    <!-- Main Wrapper -->
		<div class="main-wrapper">
		
			<!-- Header -->
                <layout-header />
			<!-- /Header -->
			
			<!-- Breadcrumb -->
			<div class="breadcrumb-bar">
				<div class="container-fluid">
					<div class="row align-items-center">
						<div class="col-md-12 col-12">
							<nav aria-label="breadcrumb" class="page-breadcrumb">
								<ol class="breadcrumb">
									<li class="breadcrumb-item"><router-link to="/index">Home</router-link></li>
									<li class="breadcrumb-item active" aria-current="page">Keuangan</li>
								</ol>
							</nav>
							<h2 class="breadcrumb-title">Keuangan</h2>
						</div>
					</div>
				</div>
			</div>
			<!-- /Breadcrumb -->
			
			<!-- Page Content -->
			<div class="content">
				<div class="custom-container">
					<div class="row">
					
						<!-- Profile Sidebar -->
						<div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                                <Sidebar />
						</div>
						<!-- /Profile Sidebar -->
						
                        
						<div class="col-md-7 col-lg-8 col-xl-9 dct-appoinment">
							<div class="card">
								<div class="card-body pt-0" style="min-height:530px">
								
									<!-- Tab Menu -->
									<nav class="user-tabs mb-4">
										<ul class="nav nav-tabs nav-tabs-bottom nav-justified">
											<li class="nav-item">
												<a class="nav-link active" href="#tablatihan" data-toggle="tab">Keuangan</a>                                                
											</li> 

											<!-- <li class="nav-item">
												<a class="nav-link" href="#tabkategori" data-toggle="tab">Kategori</a>                                                
											</li> 
                                             
											<li class="nav-item">
												<a class="nav-link" href="#tabsubject" data-toggle="tab"><span class="med-records">Subject</span></a>
											</li> -->
										</ul>
									</nav>
									<!-- /Tab Menu -->
									
									<!-- Tab Content -->
									<div class="tab-content pt-0">
										
										<!-- Materi Tab -->
										<div id="tablatihan" class="tab-pane fade show active">
                                            <div class="card card-table">
												<div class="card-body p-3">
                                                    <div class="row text-center">
                                                        <div class="col-md-6">
                                                            <div class="form-group card-label">
                                                                <!-- <label>Paket Bimbel</label> -->
                                                                <v-select
                                                                :options="lstpaket"
                                                                :reduce="lstpaket => lstpaket.id_paket" 
                                                                label="nama_paket"
                                                                v-model="id_paket"
                                                                placeholder="Silahkan pilih Paket"
                                                                required
                                                                />
                                                                
                                                            </div>
                                                        </div>
                                                        <div class="col-md-3 ">
                                                            <button class="btn btn-primary btn-sm float-left" @click.prevent="getAll()"> Lihat Jadwal </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

											<div class="card card-table mb-0">
												<div class="card-body">
                                                   
													<div class="table-responsive">
                                                        <table id="tblLatihan" class="table table-hover table-center mb-0">
                                                            <thead>
                                                                <tr>
                                                                    <th class="text-left">#</th>
                                                                    <!-- <th class="text-left">Paket Bimbel</th> -->
                                                                    <th class="text-left">Materi Pertemuan</th>
                                                                    <th class="text-left">Coach</th>
                                                                    <th class="text-left">Status Coach</th>
                                                                    <th class="text-left">Status Fee</th>
                                                                    <th class="text-left">Action</th>
                                                                </tr>
                                                            </thead>
                                        
                                                            <tbody>
                                                                
                                                                <tr v-for="(ref, index) in lstjadwal" :key="ref.id_paket_jadwal">
                                                                    <td>{{ index + 1 }}</td>
                                                                    <!-- <td>{{ ref.nama_paket }}</td> -->
                                                                    <td>{{ ref.judul_pertemuan }}</td>
                                                                    <td>{{ ref.nama_coach2 }}</td>
                                                                    <!-- <td class="text-center">{{ ref.status_coach }}</td> -->
                                                                    <td class="text-center">
                                                                        <span v-if="ref.status_coach=='1'">Assigned</span>
                                                                        <span v-if="ref.status_coach=='0'">Unassigned</span>
                                                                    </td>
                                                                    <td class="text-center">
                                                                        <span v-if="ref.status_fee=='1'">Submited</span>
                                                                        <span v-if="ref.status_fee=='0'">Draft</span>
                                                                    </td>
                                                                    <td>
                                                                        <v-btn v-if="ref.status_fee=='0' && ref.status_coach=='1'" class="btn btn-sm bg-info-light" depressed small @click.prevent="getInputFee(ref)" data-toggle="modal" data-target="#penarikanMdl" >
                                                                            <i class="fas fa-edit"></i> Input Honor
                                                                        </v-btn>
                                                                        <v-btn v-if="ref.status_fee=='1' && ref.status_coach=='1'" class="btn btn-sm bg-info-light" depressed small @click.prevent="getPreviewFee(ref)" data-toggle="modal" data-target="#penarikanMdl" >
                                                                            <i class="fas fa-edit"></i> Detail Honor
                                                                        </v-btn>
                                                                        <!-- <v-btn v-if="ref.jumlah_soal >0" class="btn btn-sm bg-warning-light" depressed small @click="getPreview(ref)">
                                                                            <i class="fas fa-eye"></i> Preview Soal
                                                                        </v-btn> -->
                                                                    </td>
                                                                </tr>
                                                            </tbody>                                            
                                                        </table>
                                                     
                                                    </div>
												</div>
											</div>
										</div>
                                        <!-- /Materi Tab -->
									
										  
									</div>
									<!-- Tab Content -->
									
								</div>
							</div>
						</div>

                        
						
					</div>
				</div>

			</div>	                          	
			<!-- /Page Content -->
   
			<!-- Footer -->
				<layout-footer />
			<!-- /Footer -->
		   
		</div>
		<!-- /Main Wrapper -->


        <div id="penarikanMdl" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered modal-md" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Form Input Honor Mengajar</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form id="frm">                            
                            <div class="row">
                                <div class="col-md-12 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Nama Paket</label>
                                        <input class="form-control" type="text" v-model="walletdtl.nama_paket" disabled="disabled">
                                    </div>
                                </div>
                                <div class="col-md-12 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Judul Pertemuan</label>
                                        <input class="form-control" type="text" v-model="walletdtl.judul_pertemuan" disabled="disabled">
                                    </div>
                                </div>
                                <div class="col-md-12 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Jadwal Pertemuan</label>
                                        <input class="form-control" type="text" v-model="walletdtl.jadwal_pertemuan" disabled="disabled">
                                    </div>
                                </div>
                                <div class="col-md-12 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Nama Coach</label>
                                        <input class="form-control" type="text" v-model="walletdtl.nama_coach2" disabled="disabled">
                                    </div>
                                </div>
                                
                                <div class="col-md-12 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Nominal Honor Mengajar</label>
                                        <!-- <input class="form-control" type="text" v-model="walletdtl.nilai_transaksi"> -->
                                        <number class="form-control" v-model="walletdtl.nilai_transaksi" v-bind="number" required :disabled="isPreviewFee"></number>

                                    </div>
                                </div>
                                
                                <!-- <div class="col-md-12 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Status Approval</label>
                                        <v-select
                                        :options="lststs"
                                        :reduce="lststs => lststs.id" 
                                        label="text"
                                        v-model="walletdtl.fg_approval"
                                        />
                                        
                                    </div>
                                </div> -->
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <div class="submit-section text-center">
                            <button class="btn btn-primary submit-btn" @click.prevent="saveFee" v-if="isInputFee">Submit</button>
                            <button class="btn btn-danger submit-btn" @click.prevent="resetFee" v-if="isPreviewFee">Reset</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        
        <div id="delMdl" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Reset Honor</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="form-group">
                                <label>Apakah anda yakin akan mereset Honor Mengajar Jadwal <b>{{ walletdtl.judul_pertemuan }}</b>?</label>
                            </div>
                            <div class="submit-section">
                                <button class="btn btn-primary submit-btn" @click.prevent="hapus">Yakin</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import Sidebar from '../Sidebar'
import axios from 'axios';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from 'jquery'
import Number  from 'vue-number-format'

export default {
    components: {
        Sidebar, Number
    },
	name: 'Keuangan',
    data() {
        return {
            lstpaket: [],
            id_paket: '',
            lstjadwal: [],
            number: {
				decimal: '.',
				separator: ',',
				prefix: 'I ',
				// suffix: ' #',
				precision: 0,
				masked: false
			},
            walletdtl: {
                id:'',
                nilai_transaksi: 0,
                pno_rekening: '',
                patas_nama: '',
                pnama_bank: '',
                fee_transfer: 5550,
                net_transfer: 0
            },
        }
    },
    created: function () {
        this.getAllPaket();
        // this.getAll();
        // this.getAllTingkatan();
        // this.getAllMateri();
        // this.getAllSubMateri();
    },  
    methods: {
        initDt(tbId) {
           setTimeout(() => {
                $('#'+tbId).DataTable({
                    "pagingType": "full_numbers",
                    "bLengthChange": false,
                    pageLength : 10,
                    // "lengthMenu": [
                    //     [10, 25, 50, -1],
                    //     [10, 25, 50, "All"]
                    // ],
                    // order: [[0, 'asc'], [3, 'desc']],
                    responsive: true,
                    destroy: true,
                    retrieve: true,
                    autoFill: true,
                    colReorder: true,

                });
               }, 300)
        },
        
        clearTbl(tbId){
            // $('#'+tbId).DataTable();
            var table = $('#'+tbId).DataTable();
            table.destroy();
        },


        //--------------------------
        // Get Materi Pertemuan
        getAllPaket: function () {
            axios.get('api/paket')
                .then(res => {
                    this.lstpaket = res.data.data;
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        // Get Materi Pertemuan
        getAll: function () {

            axios.get('api/feejadwal/'+this.id_paket)
                .then(res => {
                    // console.log(res.data);
                    this.clearTbl("tblLatihan");
                    this.lstjadwal = res.data.data;
                    this.initDt("tblLatihan");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        }, 
 
        getInputFee(ref){
            this.walletdtl =  ref;
            this.isInputFee = true;
            this.isPreviewFee = false;
        },

        getPreviewFee(ref){
            this.walletdtl =  ref;
            this.isInputFee = false;
            this.isPreviewFee = true;
        },
        
        resetFee: function () {
            $("#penarikanMdl").modal('hide');
            $("#delMdl").modal('show');
        },
        
        saveFee: function () {
            // console.log("cek isi");
            // console.log(parseInt(this.walletdtl.nilai_transaksi));
            // console.log(parseInt(this.wallet.saldo));
            if (parseInt(this.walletdtl.nilai_transaksi) < 0) {
                
                 let timerInterval
                    swal.fire({
                    title: 'Peringatan',
                    html: '<div class="success-cont">'+
                                '<i class="fas fa-times"></i>'+
                                '<h3>Nominal Honor Mengajar tidak boleh lebih kecil dari 0!</h3>'+
                                // '<p>Nilai yang anda dapatkan adalah <strong> '+this.tryout.hasil+'</strong></p>'+
                                // '<router-link to="/admin/tryout" class="btn btn-primary view-inv-btn">Selesai</router-link>'+
                            '</div>',
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: () => {
                        swal.showLoading()
                        const b = swal.getHtmlContainer().querySelector('b')
                        timerInterval = setInterval(() => {
                        b.textContent = swal.getTimerLeft()
                        }, 100)
                    },
                    willClose: () => {
                        clearInterval(timerInterval)
                    }
                    }).then((result) => {
                        
                    })
            } else{

                axios.post('api/walletfee', {
                        walletdtl: this.walletdtl
                    })
                    .then(res => {
                        // handle success
                        this.getAll();
                        // this.resetPenarikan(null);
                        $("#penarikanMdl").modal('hide');
                    })
                    .catch(err => {
                        // handle error
                        console.log(err);
                    })
            }
        },

        // Create New Materi
        goSubmit: function (ref) {
            axios.post('api/ldtsubmit', {
                    id_paket_sales: ref.id_paket_sales,
                    id_paket_jadwal: ref.id_paket_jadwal
                })
                .then(res => {
                    // handle success
                    this.getAll();
                    // this.resetVar();
                    // $("#addMdl").modal('hide');
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        
        getPreview: function (ref) {
            this.ldt = ref;
            axios.get('api/ldtpreviewsoal/'+localStorage.getItem("idUser")+'/'+ref.id_paket_sales+'/'+ref.id_paket_jadwal) //+this.$route.params.id)
                .then(res => {
                    $("#previewMdl").modal('show');

                    this.lstsoal = res.data.data;
                    // if(this.lstsoal){
                    //     this.setRowSoal(0);
                    // }
                    // console.log(this.lstsoal[0].soal.pembahasan);
                    // this.initDt("tblLatihan");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        filterKategori: function(value){
            this.tryout.id_materi = '';
            this.lstmateri = value? this.lstmateriori.filter(c => c.id_tingkatan == value) : this.lstmateriori;
        },
        
        filterSubject: function(value){
            this.tryout.id_sub_materi = '';
            this.lstsubject = value? this.lstsubmateri.filter(c => c.id_materi == value) : this.lstsubmateri;
        },


        // Get Detail and Show data to Modal
        getDetail: function (ref) {
            // nrouter.push("instructor/tryout/soal/"+ref.id_to);
            
            localStorage.setItem("id_paket_sales", ref.id_paket_sales); 
            localStorage.setItem("id_paket_jadwal", ref.id_paket_jadwal); 
            this.$router.push({name:'siswa-learndoteach-soal'}); //, params: {id_paket_sales: ref.id_sales, id_paket_jadwal: ref.id_paket_jadwal}}); 
            // this.resetVar(ref, true);
            // $("#addMdl").modal('show');
        },

       
        // Get Edit and Show data to Modal
        getEdit: function (ref) {
            this.resetVar(ref);
            $("#addMdl").modal('show');
        },

        // Get Delete and Show Confirm Modal
        getDelete: function (ref) {
            this.ldt = ref;
            $("#delMdl").modal('show');
        },
 
        // Delete Materi
        hapus: function () {
            axios.post('api/walletfeedel', {
                    id_paket_jadwal: this.walletdtl.id_paket_jadwal
                })
                .then(res => {
                    // handle success
                    
                    if(res.data.status == 'success'){
                        this.getAll();
                        $("#delMdl").modal('hide');
                        
                        let timerInterval
                        swal.fire({
                        title: 'Reset Fee',
                        html: 'Fee berhasil direset!',
                        timer: 2000,
                        // icon: 'success',
                        timerProgressBar: true,
                        didOpen: () => {
                            swal.showLoading()
                            const b = swal.getHtmlContainer().querySelector('b')
                            timerInterval = setInterval(() => {
                            b.textContent = swal.getTimerLeft()
                            }, 100)
                        },
                        willClose: () => {
                            clearInterval(timerInterval)
                        }
                        }).then((result) => {
                        /* Read more about handling dismissals below */
                        if (result.dismiss === swal.DismissReason.timer) {
                            console.log('I was closed by the timer')
                        }
                        })
                    }
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
        
        //--------------------------
        // Get Tingkatan
        getAllTingkatan: function () {
            axios.get('api/reftingkatan')
                .then(res => {
                    // console.log(res.data);
                    this.lsttingkatan = res.data.data;
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        // Get Materi
        getAllMateri: function () {
            axios.get('api/materi')
                .then(res => {
                    // console.log(res.data);
                    this.lstmateri = res.data.data;
                    this.lstmateriori = res.data.data;
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        // Get sub_materi
        getAllSubMateri: function () {
            axios.get('api/submateri')
                .then(res => {
                    // console.log(res.data);
                    this.lstsubmateri = res.data.data;
                    this.lstsubject = this.lstsubmateri;
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        getHasilTryout: function (ref) {
            axios.get('api/tryoutres/'+ref.id_to)
                .then(res => {
                    // console.log(res.data);
                    $("#hasilMdl").modal('show');
                    this.lsthasil = res.data.data;
                    this.initDt("tblHasil");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
 
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Keuangan/index.vue